// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-colour-tiles.liquid so the browser can cache it. Code unchanged.
    /* 14 Oct 2026: keep the shopper's size when they tap another colour. */
    (function () {
      var root = document.currentScript && document.currentScript.closest('[data-adct]');
      if (!root) return;
      var M;
      try { M = JSON.parse(root.querySelector('[data-adct-map]').textContent); } catch (e) { return; }
      function N(s) { return String(s == null ? '' : s).toLowerCase().replace(/cm/g, '').replace(/[^a-z0-9]/g, ''); }
      function curSize() {
        /* 14 Oct 2026: the active Size value in the page options first (it changes as soon as a size is tapped), then the variant select, then ?variant= */
        var opts = root.closest('[data-js-product-options]') || document.querySelector('.product-options--type-page[data-js-product-options]');
        var a = opts && opts.querySelector('[data-property*="size"] .active');
        if (a) return a.getAttribute('data-value');
        var sel = document.querySelector('select[name="id"][data-js-product-variants]');
        if (sel && sel.value && M.cur[sel.value] != null) return M.cur[sel.value];
        var q = new URLSearchParams(location.search).get('variant');
        if (q && M.cur[q] != null) return M.cur[q];
        return null;
      }
      function update(forced) {
        var s = N(forced != null ? forced : curSize());
        root.querySelectorAll('[data-adct-tile]').forEach(function (t) {
          var m = M.sib[t.getAttribute('data-handle')] || {};
          var base = t.getAttribute('data-url');
          var note = t.querySelector('.adct__n');
          var hit = null;
          for (var k in m) { if (N(k) === s) { hit = m[k]; break; } }
          var msg = '';
          if (hit) {
            t.setAttribute('href', base + '?variant=' + hit.id);
            if (!hit.available) msg = 'Sold out in this size';
          } else {
            t.setAttribute('href', base);
            if (s) msg = 'Not in this size';
          }
          if (note) { note.textContent = msg; note.hidden = !msg; }
          t.classList.toggle('is-dim', !!msg);
        });
        if (pvTile) setGo(pvTile); /* 15 Oct 2026: keep the View button in step with the size */
        return s;
      }

      /* 15 Oct 2026: colour preview. An overlay <img> sits over the visible gallery slide; the slider is not touched. */
      var pvTile = null, pvEl = null, preloaded = false;
      var go = root.querySelector('[data-adct-go]');
      var touch = window.matchMedia ? window.matchMedia('(hover: none)') : { matches: false };
      function wrap() { return document.querySelector('[data-js-product-gallery-main-slider-wrapper]'); }
      function preload() {
        if (preloaded) return; preloaded = true;
        root.querySelectorAll('[data-adct-tile][data-img]').forEach(function (t) { var i = new Image(); i.src = t.getAttribute('data-img'); });
      }
      function sizeText() {
        var c = curSize(); if (!c) return '';
        return String(c).replace(/(\d)\s*x\s*(\d)/i, '$1 x $2').replace(/(\d)\s*cm/i, '$1 cm').trim();
      }
      function setGo(t) {
        if (!go) return;
        var lab = t.getAttribute('data-label') || '';
        var dim = t.classList.contains('is-dim') && /Not in/.test((t.querySelector('.adct__n') || {}).textContent || '');
        var sz = dim ? '' : sizeText();
        go.textContent = 'View ' + lab + (sz ? ' in ' + sz : '');
        go.setAttribute('href', t.getAttribute('href'));
      }
      function show(t) {
        var w = wrap(), src = t.getAttribute('data-img');
        if (!w || !src) return;
        var cur = w.querySelector('.slick-current') || w.querySelector('.product-gallery__main_item');
        if (!cur) return;
        var wr = w.getBoundingClientRect(), cr = cur.getBoundingClientRect();
        if (!pvEl) {
          pvEl = document.createElement('div');
          pvEl.className = 'adct-pv';
          pvEl.setAttribute('aria-hidden', 'true');
          pvEl.innerHTML = '<img alt=""><span class="adct-pv__l"></span>';
        }
        /* the product box can be CSS-zoomed on wide screens (adore-pdp-style), so screen pixels are divided by that zoom */
        var z = w.offsetWidth ? wr.width / w.offsetWidth : 1; if (!z) z = 1;
        pvEl.style.left = ((cr.left - wr.left) / z) + 'px';
        pvEl.style.top = ((cr.top - wr.top) / z) + 'px';
        pvEl.style.width = (cr.width / z) + 'px';
        pvEl.style.height = (cr.height / z) + 'px';
        pvEl.querySelector('img').src = src;
        pvEl.querySelector('.adct-pv__l').textContent = 'Previewing: ' + (t.getAttribute('data-label') || '');
        if (pvEl.parentNode !== w) w.appendChild(pvEl);
        pvTile = t;
      }
      function restore() {
        if (pvEl && pvEl.parentNode) pvEl.parentNode.removeChild(pvEl);
        if (pvTile) pvTile.classList.remove('is-pv');
        pvTile = null;
        if (go) go.hidden = true;
      }
      window.adoreColourPreview = { show: show, restore: restore, preload: preload, state: function () { return { tile: pvTile && pvTile.getAttribute('data-handle'), src: pvEl && pvEl.parentNode ? pvEl.querySelector('img').src : null, go: go && !go.hidden ? go.getAttribute('href') : null, goText: go && !go.hidden ? go.textContent : null }; } };
      function bindPreview() {
        root.addEventListener('pointerenter', preload, true);
        root.addEventListener('focusin', preload);
        root.querySelectorAll('[data-adct-tile]').forEach(function (t) {
          t.addEventListener('mouseenter', function () { if (!touch.matches) show(t); });
          t.addEventListener('mouseleave', function () { if (!touch.matches) restore(); });
          t.addEventListener('focus', function () { if (!touch.matches) show(t); });
          t.addEventListener('blur', function () { if (!touch.matches) restore(); });
          /* 17 Oct 2026 (Nas, phone recording: tapping between tiles "freezes"): on phones the first tap only previewed the
             colour in the main photo, which is off screen above the tiles, so nothing seemed to happen. Every tap now goes
             straight to that colour, keeping the size (the tile's href already carries ?variant=). Desktop keeps the hover preview. */
          t.addEventListener('click', function () { restore(); });
        });
        var curT = root.querySelector('.adct__t[aria-current="true"]');
        if (curT) curT.addEventListener('click', restore);
        var w = wrap();
        if (w) w.addEventListener('pointerdown', function () { if (pvTile) restore(); });
      }
      window.adoreColourTilesUpdate = update;
      var later = function () { setTimeout(update, 0); setTimeout(update, 350); };
      function init() {
        update();
        bindPreview(); /* 15 Oct 2026 */
        document.addEventListener('change', later);
        document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-js-product-options]')) later(); });
        window.addEventListener('popstate', later);
        if (window.MutationObserver) {
          var mo = new MutationObserver(later);
          document.querySelectorAll('[data-js-product-options], select[name="id"][data-js-product-variants]').forEach(function (el) {
            mo.observe(el, { attributes: true, subtree: true, childList: true, attributeFilter: ['class', 'selected'] });
          });
        }
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    })();
  
